import { render, staticRenderFns } from "./index.vue?vue&type=template&id=411641cd&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "411641cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('411641cd')) {
      api.createRecord('411641cd', component.options)
    } else {
      api.reload('411641cd', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=411641cd&scoped=true", function () {
      api.rerender('411641cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/deliverGoods/takeGoods/deliveryAddress/index.vue"
export default component.exports